import React, { useState, useEffect } from 'react';
import { FaStar, FaChevronDown } from "react-icons/fa6";

const TestimonialBox = ({ testimonialDescription, testimonialName, testimonialDesignation }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isButtonVisible, setIsButtonVisible] = useState(false);
    useEffect(() => {
        const contentElement = document.querySelector('.content');
        if (contentElement) {
            const computedStyle = window.getComputedStyle(contentElement);
            const textHeight = contentElement.scrollHeight;
            const lineHeight = parseFloat(computedStyle.lineHeight);
            const rows = Math.round(textHeight / lineHeight);

            setIsButtonVisible(rows > 3);
        }
    }, [testimonialDescription]);

    const toggleReadMore = () => {
        setIsExpanded(!isExpanded);
    };
    return (
        <>
            <div className="testimonialBox">
                <div className="testimonialBoxStar">
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                </div>
                <div className="testimonialBoxBody">
                    <p className={`content ${isExpanded ? 'expanded' : ''}`}>
                        {testimonialDescription}
                    </p>
                    {isButtonVisible && (
                        <button className="read-more" onClick={toggleReadMore}>
                            {isExpanded ? 'Read Less' : 'Read More'} <FaChevronDown />
                        </button>
                    )}
                </div>
                <div className="testimonialBoxFooter">
                    <h3>{testimonialName}</h3>
                    <h4>{testimonialDesignation}</h4>
                </div>
            </div>
        </>
    );
};

export default TestimonialBox;